import { atom, selector } from 'recoil'
import { editorState } from './editor'

export const modalBeeSavedRowMetadataState = atom({
  key: 'modalBeeSavedRowMetadataState',
  default: {
    show: false,
    onConfirm: undefined,
    onCancel: undefined,
    resolveMetadata: false,
    row: undefined,
    metadata: {
      name: undefined
    },
    mode: ''
  }
})

export const backUrlState = selector({
  key: 'modalBeeSavedRowbackUrlState',
  get: ({ get }) => {
    const { id, idTemplate, template } = get(editorState)
    const ret =
      id === 0
        ? `/messages/email/bee/new/${template}/${idTemplate}`
        : `/messages/email/bee/edit/${id}`

    return ret
  }
})
